import { fromJS } from 'immutable';

import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import { GetHelpdeskCS } from '../../../store/constants'
import doFetch from '../../../infra/helper/fetchHelper'

export default (csid) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl2 + 'config-cs-view';    
    var paramBody = {
        "data":{
            "cs-id":csid
        }
    }

    const argument = {  
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };  

    const response = await doFetch(url,argument);
    return response;
};